import { render, staticRenderFns } from "./CoEmojiPicker.vue?vue&type=template&id=7fc3f165&scoped=true&"
import script from "./CoEmojiPicker.vue?vue&type=script&lang=ts&"
export * from "./CoEmojiPicker.vue?vue&type=script&lang=ts&"
import style0 from "./CoEmojiPicker.vue?vue&type=style&index=0&id=7fc3f165&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc3f165",
  null
  
)

export default component.exports